/**
 * Simulation générale des touchevents en mouseevents : https://stackoverflow.com/questions/1517924/javascript-mapping-touch-events-to-mouse-events
 */
class BlockBeforeAfter {

	/**
	 * Public vars
	 */
	contextDocument = document;
	element = null;
	elementAfter = null;
	elementControl = null;
	initCoverPercent = 50;

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	constructor( element )
	{
		this.element = element;
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onDisplayControlMouseDown = this.onDisplayControlMouseDown.bind( this );
		this.onMouseMove = this.onMouseMove.bind( this );
		this.onMouseUp = this.onMouseUp.bind( this );
		this.onTouchEnd = this.onTouchEnd.bind( this );
		this.onTouchMove = this.onTouchMove.bind( this );
		this.onTouchStart = this.onTouchStart.bind( this );

		this.elementAfter = this.element.querySelector( ':scope > .block-inner > .after' );

		if ( ! this.elementAfter )
		{
			console.warn( 'unable to find element after' );
		}
	}

	/**
	 * 
	 */
	clear()
	{
		this.elementControl.removeEventListener( 'mousedown', this.onDisplayControlMouseDown );
		this.contextDocument.removeEventListener( 'mouseup', this.onMouseUp );
		this.contextDocument.removeEventListener( 'mousemove', this.onMouseMove );

		this.removeControls();
	}

	/**
	 * 
	 */
	setup()
	{
		this.createControls();

		this.elementControl.addEventListener( 'mousedown', this.onDisplayControlMouseDown );
		this.elementControl.addEventListener( 'touchstart', this.onTouchStart );
		this.contextDocument.addEventListener( 'mouseup', this.onMouseUp );
		this.contextDocument.addEventListener( 'touchend', this.onTouchEnd );

		this.setCoverTo( this.initCoverPercent );
	}

	/**
	 * 
	 */
	createControls()
	{
		this.elementControl = this.contextDocument.createElement( 'div' );
		this.elementControl.classList.add( 'control' );

		const elementBar = this.contextDocument.createElement( 'div' );
		elementBar.classList.add( 'control-bar' );

		const elementButton = this.contextDocument.createElement( 'div' );
		elementButton.classList.add( 'control-button' );

		const elementButtonInner = this.contextDocument.createElement( 'div' );
		elementButtonInner.classList.add( 'control-button-inner' );

		elementButton.appendChild( elementButtonInner );
		this.elementControl.appendChild( elementBar );
		this.elementControl.appendChild( elementButton );
		this.element.appendChild( this.elementControl );
	}

	/**
	 * 
	 */
	removeControls()
	{
		this.elementControl.remove();
	}

	/**
	 * 
	 * @param {Number} percent 
	 */
	setCoverTo( percent )
	{
		percent = Math.min( 100, Math.max( 0, percent ) );

		this.elementAfter.style.clipPath = `inset( 0 0 0 ${ percent }% )`;
		this.elementControl.style.left = `${ percent }%`;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onDisplayControlMouseDown( event )
	{
		event.preventDefault();
		this.contextDocument.addEventListener( 'mousemove', this.onMouseMove );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onMouseMove( event )
	{
		const rect = this.element.getBoundingClientRect();
		const relativeLeft = event.clientX - rect.left;
		this.setCoverTo( relativeLeft / rect.width * 100 );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onMouseUp( event )
	{
		this.contextDocument.removeEventListener( 'mousemove', this.onMouseMove );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onTouchStart( event )
	{
		event.preventDefault();
		this.contextDocument.addEventListener( 'touchmove', this.onTouchMove );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onTouchMove( event )
	{
		const touch = event.changedTouches[0];
		const rect = this.element.getBoundingClientRect();
		const relativeLeft = touch.clientX - rect.left;
		this.setCoverTo( relativeLeft / rect.width * 100 );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onTouchEnd( event )
	{
		this.contextDocument.removeEventListener( 'touchmove', this.onTouchMove );
	}

}

export default BlockBeforeAfter;